import { TimeSlot } from '../../../types/model';
import { isRegistrationClosed, toTimestamp } from '../../../utils';
import Status from '@ingka/status';
import {
  CHECKIN,
  REGISTERED,
  SELF_CHECKIN,
  WAITING_LIST,
} from '../../Register/enums';

export default function getCaption(
  timeSlot: TimeSlot,
  registeredToTimeSlot: string,
  registrationState: string,
  t: Function
) {
  const {
    remainingSpots = 0,
    utcRegistrationClosedDate,
    registerToWaitingList,
    timeslotId,
  } = timeSlot;

  if (timeslotId === registeredToTimeSlot) {
    const copy: { [key: string]: string } = {
      [REGISTERED]: 'event.youAreRegistered',
      [CHECKIN]: 'event.youAreRegistered',
      [SELF_CHECKIN]: 'event.youAreRegistered',
      [WAITING_LIST]: 'event.youAreRegisteredWaitingList',
    };

    return <Status label={t(copy[registrationState])} statusColor="green" />;
  }

  if (isRegistrationClosed(toTimestamp(utcRegistrationClosedDate as number))) {
    return t('event.registerClosed');
  }

  if (remainingSpots === 0) {
    return `${t('event.fullyBooked')}${
      registerToWaitingList ? ` - ${t('event.waitingList')}` : ''
    }`;
  }

  if (remainingSpots <= 5) {
    return `${t('event.onlySpotsLeft', { remainingSpots })}`;
  }

  if (remainingSpots === Number.MAX_SAFE_INTEGER) {
    return '';
  }

  return `${t('event.spotsRemaining', { remainingSpots })}`;
}
